import type { ModalPriority } from 'components/ui/Modal/Modal';

export const DEFAULT_MODAL_PRIORITY: ModalPriority = 3;
